import { jsx as _jsx } from "react/jsx-runtime";
import { Card } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { termsOfServiceStepIndex } from '~/client-flow/clientOb/ClientOnboarding.common.utils';
import { useCobConfig } from '~/client-flow/clientOb/CobConfigContext';
import styles from './TermsOfService.module.scss';
import { TermsOfServiceContent } from './TermsOfServiceContent';
export const { TermsOfServicesTestIds } = getTestIds();
export const TermsOfService = (param)=>{
    let { currentStep } = param;
    var _termsOfServiceStepIndex_currentStep;
    var _relationship_legalTermsDocuments;
    const { relationship } = useCobConfig();
    const termsOfServiceIndex = (_termsOfServiceStepIndex_currentStep = termsOfServiceStepIndex[currentStep]) !== null && _termsOfServiceStepIndex_currentStep !== void 0 ? _termsOfServiceStepIndex_currentStep : 0;
    const termsOfService = (_relationship_legalTermsDocuments = relationship.legalTermsDocuments) === null || _relationship_legalTermsDocuments === void 0 ? void 0 : _relationship_legalTermsDocuments[termsOfServiceIndex];
    if (!termsOfService) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Card, {
        className: styles.card,
        testId: TermsOfServicesTestIds.Root(),
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.content,
            children: /*#__PURE__*/ _jsx(TermsOfServiceContent, {
                relationship: relationship,
                termsOfService: termsOfService
            })
        })
    });
};
